// calendar-reschedule store — подсветка перемещённых уроков после reschedule.
//
// Socket `study-plan:calendar.ready` (listener в __root) помечает planId как
// «недавно обновлён» → PlanMonthGrid/agenda подсвечивают уроки этого плана
// subtle ring-primary/40 на 1 загрузку, флаг гаснет по interaction (clear) или
// автоматически через TTL. Эфемерный UI-state — без persist.

import { create } from "zustand";

/** Авто-сброс подсветки, если пользователь не взаимодействовал. */
const HIGHLIGHT_TTL_MS = 8000;

interface CalendarRescheduleState {
	/** planId → timestamp пометки. */
	highlighted: Record<string, number>;
	/** Пометить план как недавно перепланированный (подсветить уроки). */
	markRescheduled: (planId: string) => void;
	/** Снять подсветку конкретного плана (по interaction). */
	clear: (planId: string) => void;
	/** Снять всю подсветку. */
	clearAll: () => void;
}

export const useCalendarRescheduleStore = create<CalendarRescheduleState>((set) => ({
	highlighted: {},
	markRescheduled: (planId) => {
		set((s) => ({ highlighted: { ...s.highlighted, [planId]: Date.now() } }));
		// Авто-сброс по TTL (если interaction не снял раньше).
		setTimeout(() => {
			set((s) => {
				const ts = s.highlighted[planId];
				if (ts == null || Date.now() - ts < HIGHLIGHT_TTL_MS - 100) return s;
				const { [planId]: _removed, ...rest } = s.highlighted;
				return { highlighted: rest };
			});
		}, HIGHLIGHT_TTL_MS);
	},
	clear: (planId) =>
		set((s) => {
			if (!(planId in s.highlighted)) return s;
			const { [planId]: _removed, ...rest } = s.highlighted;
			return { highlighted: rest };
		}),
	clearAll: () => set({ highlighted: {} }),
}));
